import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { NAV_LINKS, GROWTH_FACTOR_URL, CONTACT_INFO } from "../../data/config";
import { SocialIcons } from "../common/SocialIcons";

export const Footer = () => (
  <footer className="bg-ink text-warmwhite" data-testid="site-footer">
    <div className="container-site grid gap-12 py-20 md:grid-cols-4">
      <div>
        <img src="/images/logo.png" alt="iINSPIRE — Irma Ariandi" className="h-12 w-auto bg-warmwhite px-2 py-1" />
        <p className="mt-4 text-sm text-warmwhite/70">{CONTACT_INFO.tagline}</p>
        <SocialIcons className="mt-8 text-warmwhite" />
      </div>
      <nav aria-label="Footer navigation">
        <p className="eyebrow">Ecosystem</p>
        <ul className="mt-6 space-y-3">
          {NAV_LINKS.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-sm text-warmwhite/70 transition-colors duration-300 hover:text-amber"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div>
        <p className="eyebrow">Growth Factor</p>
        <p className="mt-6 text-sm leading-relaxed text-warmwhite/70">
          Our digital diagnostic ecosystem for personal, business and
          organisational clarity.
        </p>
        <a
          href={GROWTH_FACTOR_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-growth-factor-link"
          className="mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-amber transition-colors duration-300 hover:text-goldbright"
        >
          growthfactor.iinspire.my <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
        </a>
      </div>
      <div>
        <p className="eyebrow">Contact</p>
        <p className="mt-6 flex items-center gap-3 text-sm text-warmwhite/70">
          <Phone className="h-4 w-4 shrink-0 text-amber" strokeWidth={1.5} />
          <a href={`tel:+6${CONTACT_INFO.phone.replace(/[^0-9]/g, "")}`} className="hover:text-amber" data-testid="footer-phone">
            {CONTACT_INFO.phone}
          </a>
        </p>
        <p className="mt-3 flex items-center gap-3 text-sm text-warmwhite/70">
          <Mail className="h-4 w-4 shrink-0 text-amber" strokeWidth={1.5} />
          <a href={`mailto:${CONTACT_INFO.email}`} className="break-all hover:text-amber" data-testid="footer-email">
            {CONTACT_INFO.email}
          </a>
        </p>
      </div>
    </div>
    <div className="border-t border-warmwhite/10">
      <div className="container-site flex flex-col gap-3 py-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-serif text-lg italic text-amber">Let&apos;s Inspire Possibilities.</p>
        <p className="text-xs tracking-wide text-warmwhite/50">
          © {new Date().getFullYear()} iINSPIRE — Irma Ariandi Global Sdn Bhd. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
